(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cryptoPro", [], factory);
	else if(typeof exports === 'object')
		exports["cryptoPro"] = factory();
	else
		root["cryptoPro"] = factory();
})(window, function() {
return 